import { rPage } from "./recoil";
import { useRecoilValue } from "recoil";

const usePage = () => {
  const page = useRecoilValue(rPage);
  return page;
};

export default usePage;
